export default {"src":"/_next/static/media/pc-play-media.0e69c013.svg","height":20,"width":20};